import { Loader2 } from "lucide-react";
import { hapticMedium } from "@/lib/haptics";

const VARIANT_CLASS = {
  primary: "kipa-btn-primary",
  secondary: "kipa-btn-secondary",
  ghost: "kipa-btn-ghost",
  danger: "kipa-btn-danger",
  success: "kipa-btn-success",
};

const SIZE_CLASS = {
  sm: "kipa-btn-sm",
  md: "kipa-btn-md",
  lg: "kipa-btn-lg",
};

export default function KipaButton({
  variant = "primary",
  size = "md",
  label,
  children,
  onPress,
  onClick,
  disabled = false,
  loading = false,
  fullWidth = false,
  icon,
  type = "button",
  testId,
  className = "",
}) {
  const handleClick = (e) => {
    if (disabled || loading) return;
    if (variant === "primary") hapticMedium();
    (onPress || onClick)?.(e);
  };

  return (
    <button
      type={type}
      onClick={handleClick}
      disabled={disabled || loading}
      data-testid={testId}
      className={`kipa-btn kipa-btn-press ${VARIANT_CLASS[variant] || VARIANT_CLASS.primary} ${SIZE_CLASS[size] || SIZE_CLASS.md} ${fullWidth ? "kipa-btn-full" : ""} ${className}`}
    >
      {loading ? (
        <Loader2 className="kipa-btn-spinner" size={18} aria-hidden />
      ) : icon ? (
        <span className="kipa-btn-icon">{icon}</span>
      ) : null}
      <span>{children ?? label}</span>
    </button>
  );
}
